import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import Carousel from "react-bootstrap/Carousel";
import { ReactComponent as IconClose } from '../../assets/images/icons/icon-modal-close.svg'


const ImageZoomModal = ({imageShow,setImageShow,imageGet}) => {

       switch(typeof imageGet){
        case "string" :
          return (
            <Modal style={{backdropFilter: 'blur(2px)'}} centered show={imageShow} onHide={()=>setImageShow(false)} className='zoom-image-modal'>
            <Modal.Body>
              <div className='close' onClick={()=>{setImageShow(false)}}><IconClose/></div>
            <img src={imageGet}  alt="variant" />    
            </Modal.Body>
          </Modal>
          )
          
          case "object":
          if (imageGet === null || imageGet === undefined) {
            return null;
          }
            const AllImages2 = Object?.values(imageGet);
             return(
            <Modal  style={{backdropFilter: 'blur(2px)'}} centered show={imageShow} onHide={()=>setImageShow(false)} className='zoom-image-modal'>
            <Modal.Body>
              <div className='close' style={{zIndex:"999"}} onClick={()=>{setImageShow(false)}}><IconClose/></div>
             <Slider AllImages2={AllImages2} />
                  </Modal.Body>
                </Modal>
             )
            default:
                return null; 
  }
       }

export default ImageZoomModal



const Slider=({AllImages2})=>{
  return(
    <Carousel data-bs-theme="dark"
    indicators={true}
    controls={true}
    fade={false}  //true
    autoPlay={true}
    interval={1000}  // 5000 || 500 || 2000
    pause="hover" // "false" 
    >
     {AllImages2?.map((final, index) =>
       {
         return (
           <Carousel.Item>
           <img src={final.image} alt="SliderData" key={index} />
        </Carousel.Item>
         )
       }
       )}
     </Carousel>
  )
}